import ApiService from "../../api/api.service";
import { GET_LIABILITY_FORM, SAVE_LIABILITY_FORM_DETAIL, GET_LIABILITY_FORM_DETAIL, GET_EDIT_LIABILITY_FORM_DETAIL, 
 UPDATE_LIABILITY_FORM, DELETE_LIABILITY_FORM, GET_STUDENT_FORM, GET_PERSONAL_FORM, GET_CAR_FORM, GET_POLICY_FORM, 
 GET_OVER_DRAFT_FORM, GET_CONSUMER_FORM, GET_LOANAGAINST_FORM, GET_TWOWHEELER_FORM, GET_CREDIT_CARD_FORM} from "../actions.type";

const getDefaultHomeloanState = () => {
	return {
		liabilityForm: {},
		saveLiabilityFormDetail: {},
		liabilityFormDetail: {},
		editLiabilityFormDetail: {},
		updateLiabilityForm: {},
		deleteLiabilityForm: {},
		studentForm: {},
		personalForm: {},
		carForm: {},
		policyForm: {},
		overDraftForm: {},
		consumerForm: {},
		loanAgainstForm: {},
		twoWheelerForm: {},
		creditCardForm: {},
	}
};

const state = getDefaultHomeloanState();

const getters = {

	getLiabilityForm(state) {
		return state.liabilityForm;
	},
	getSaveLiabilityFormDetail(state) {
		return state.saveLiabilityFormDetail;
	},
	getLiabilityFormDetail(state) {
		return state.liabilityFormDetail;
	},
	getEditLiabilityFormDetail(state) {
		return state.editLiabilityFormDetail;
	},
	getUpdateLiabilityForm(state) {
		return state.updateLiabilityForm;
	},
	getDeleteLiabilityForm(state) {
		return state.deleteLiabilityForm;
	},
	getStudentForm(state) {
		return state.studentForm;
	},
	getPersonalForm(state) {
		return state.personalForm;
	},
	getCarForm(state) {
		return state.carForm;
	},
	getPolicyForm(state) {
		return state.policyForm;
	},
	getOverDraftForm(state) {
		return state.overDraftForm;
	},
	getConsumerForm(state) {
		return state.consumerForm;
	},
	getTwoWheelerForm(state) {
		return state.twoWheelerForm;
	},
	getLoanAgainstForm(state) {
		return state.loanAgainstForm;
	},
	getCreditCardForm(state) {
		return state.creditCardForm;
	},
};

const mutations = {

	setLiabilityForm (state, data) {
		state.liabilityForm = data
	},
	setSaveLiabilityFormDetail (state, data) {
		state.saveLiabilityFormDetail = data
	},
	setLiabilityFormDetail (state, data) {
		state.liabilityFormDetail = data
	},
	setEditLiabilityFormDetail (state, data) {
		state.editLiabilityFormDetail = data
	},
	setUpdateLiabilityForm (state, data) {
		state.updateLiabilityForm = data
	},
	setDeleteLiabilityForm (state, data) {
		state.deleteLiabilityForm = data
	},
	setStudentForm (state, data) {
		state.studentForm = data
	},
	setPersonalForm (state, data) {
		state.personalForm = data
	},
	setCarForm (state, data) {
		state.carForm = data
	},
	setPolicyForm(state, data) {
		state.policyForm = data;
	},
	setOverDraftForm(state, data) {
		state.overDraftForm = data;
	},
	setConsumerForm(state, data) {
		state.consumerForm = data;
	},
	setTwoWheelerForm(state, data) {
		state.twoWheelerForm = data;
	},
	setLoanAgainstForm(state, data) {
		state.loanAgainstForm = data;
	},
	setCreditCardForm(state, data) {
		state.creditCardForm = data;
	},
};


const actions = {

	[GET_LIABILITY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLiabilityForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_LIABILITY_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveLiabilityFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_LIABILITY_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLiabilityFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EDIT_LIABILITY_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditLiabilityFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_LIABILITY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateLiabilityForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[DELETE_LIABILITY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDeleteLiabilityForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_STUDENT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setStudentForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PERSONAL_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPersonalForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_CAR_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCarForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_POLICY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPolicyForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_OVER_DRAFT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setOverDraftForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_CONSUMER_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setConsumerForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_TWOWHEELER_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setTwoWheelerForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_LOANAGAINST_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLoanAgainstForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_CREDIT_CARD_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCreditCardForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},

};

export default {
	getters,
	actions,
	mutations,
	state
}